import { createAction } from '@reduxjs/toolkit';

import { ListAllowanceTokenType } from './type';

export const actionDataListAllowanceFromToken = createAction<ListAllowanceTokenType>("actionDataListAllowanceFromToken");
export const actionDataListAllowanceToToken = createAction<ListAllowanceTokenType>("actionDataListAllowanceToToken");
export const actionGetAllowanceToken = createAction<{ address: string }>("actionGetAllowanceToken");
export const getDataCrossChain = createAction<{ data: any }>("getDataCrossChain");
